export const INPUTS_CONFIG = {
  UPLOAD: {
    MAX_FILE_SIZE: 4194304,
    ACCEPTED_FILE_TYPES: 'image/jpeg, image/jpg, image/png, image/gif, .heic',
  },
};

export const PRIVATE_MESSAGE_INPUT_CONFIG = {
  ACCEPTED_FILE_TYPES:
    '.jpg, .jpeg, .tiff, .gif, .png, .mkv, .mp4, .avi, .mov, .wmv, .3gp, .ts, .m3u8, .webm',
};

export const SEND_TWEET_ATTACHMENT_CONFIG = { ACCEPTED_FILE_TYPES: '.jpg, .jpeg, .gif, .png, .webp' };

export const STEPPER_NO_STEP = -1;
export const STEPPER_OWNER_VERIFY = {
  UPLOAD_ID: 0,
  VERIFY_SNAPSHOT: 1,
};

export const DATETIME_PICKER_MODE = {
  RANGE: 'range',
  MULTIPLE: 'multiple',
  SINGLE: 'single',
};

export const SHOP_INPUTS = {
  MAX_TITLE: 55,
  MAX_DESCRIPTION: 255,
  MAX_TAGS: 55,
  MAX_PRICE: 9999999,
};

export const MIN_USERNAME_LENGTH = 4;
export const MAX_USERNAME_LENGTH = 15;
export const MIN_STUDIO_LENGTH = 4;
export const MAX_STUDIO_LENGTH = 128;
export const MIN_PASSWORD_LENGTH = 6;
export const MAX_PASSWORD_LENGTH = 128;
export const SPECIAL_CHARS_PASSWORD = '0123456789!#$%&()*+,.:;<>=?@^_{|}][';
